import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { WalletProvider, useWallet } from "@/context/WalletContext";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Dashboard from "@/pages/Dashboard";
import Docs from "@/pages/Docs";

function Protected({ children }) {
  const { ready, connected } = useWallet();
  if (!ready)
    return (
      <div className="flex min-h-screen items-center justify-center bg-welock-bg">
        <span className="font-mono text-xs uppercase tracking-widest text-welock-textMuted">
          Loading protocol
        </span>
      </div>
    );
  if (!connected) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <WalletProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/docs" element={<Navigate to="/docs/introduction" replace />} />
            <Route path="/docs/:slug" element={<Docs />} />
            <Route
              path="/app/*"
              element={
                <Protected>
                  <Dashboard />
                </Protected>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          position="bottom-right"
          theme="dark"
          toastOptions={{
            style: {
              background: "#111318",
              border: "1px solid #1E222D",
              color: "#F3F4F6",
              borderRadius: "2px",
              fontFamily: "JetBrains Mono, monospace",
              fontSize: "13px",
            },
          }}
        />
      </WalletProvider>
    </div>
  );
}

export default App;
